import { TextFont } from "./types";

export enum ObjectType {
  TEXT_BLOCK = "TEXT_BLOCK",
  RECT_OBJ = "RECT_OBJ",
  PATH_OBJ = "PATH_OBJ",
  TEXT_OBJ = "TEXT_OBJ",
  GROUP = "GROUP",
}

export enum TextAlign {
  LEFT = "left",
  CENTER = "center",
  RIGHT = "right",
}

export enum FillBackgroundType {
  EMPTY = "empty",
  ACTIVE = "active",
  ACTIVE_INVERT = "activeInvert",
}

export enum FontsType {
  COURIER_NEW = "COURIER_NEW",
  CAVEAT_BRUSH = "CAVEAT_BRUSH",
  INTER = "INTER",
  TINOS = "TINOS",
  VOLLKORN = "VOLLKORN",
}

export const textFonts: Record<FontsType, TextFont> = {
  [FontsType.COURIER_NEW]: {
    name: "Courier New",
    icon: "sci-font-courier-prime",
  },
  [FontsType.CAVEAT_BRUSH]: {
    name: "Caveat Brush",
    icon: "sci-font-caveat-brush",
  },
  [FontsType.INTER]: {
    name: "Inter",
    icon: "sci-font-inter",
  },
  [FontsType.TINOS]: {
    name: "Tinos",
    icon: "sci-font-tinos",
  },
  [FontsType.VOLLKORN]: {
    name: "Vollkorn",
    icon: "sci-font-vollkorn",
  },
};

export const colorList = [
  "rgb(255,255,255)",
  "rgb(0,0,0)",
  "rgb(209, 82, 93)",
  "rgb(229, 147, 75)",
  "rgb(234, 190, 59)",
  "rgb(137, 193, 93)",
  "rgb(79, 126, 218)",
  "rgb(114, 52, 245)",
  "rgb(250, 201, 205)",
  "rgb(250, 217, 169)",
  "rgb(255, 248, 185)",
  "rgb(200, 255, 215)",
  "rgb(197, 232, 253)",
  "rgb(218, 218, 255)",
  "rgb(252, 204, 241)",
  "rgb(91, 91, 98)",
];
